/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Hero_Image_MobileInputs */

const vi_shop_home_hero_image_mobile = /** @type {(inputs: Shop_Home_Hero_Image_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh điện thoại`)
};

/**

* @param {Shop_Home_Hero_Image_MobileInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_hero_image_mobile = /** @type {((inputs?: Shop_Home_Hero_Image_MobileInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Hero_Image_MobileInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_hero_image_mobile(inputs)
});